import { RouteObject } from 'react-router';

import { PracticesPageLazy } from './page.tsx';

import { RoleProtectedRoute } from '@/services/roles';
import { EAdminRoutes } from '@/services/router/enums';

export const PRACTICES_ROUTE: RouteObject = {
    path: EAdminRoutes.Practices,
    element: (
        <RoleProtectedRoute path={EAdminRoutes.Practices}>
            <PracticesPageLazy />
        </RoleProtectedRoute>
    ),
};
